import axios from 'axios';

import { BlueprintMetadataData } from '@rta/rta-blueprint-library';

export type PatchBlueprintMetadataParams = {
	customerEmail: string;
	designId: string;
	metadata: Partial<BlueprintMetadataData>;
	thumbnail?: string;
	/** CRM deal to pair with this design. An empty string unpairs it. */
	dealId?: string;
	/** Version-specific 3D snapshot (inline base64) written onto the active kitchen version as the design-package's WebGL-disabled fallback. */
	designPackageImage?: string;
	getToken: () => Promise<string>;
	mode: string;
};

export const patchBlueprintMetadata = async (params: PatchBlueprintMetadataParams): Promise<[boolean, string | null]> => {
	const { customerEmail, designId, metadata, thumbnail, dealId, designPackageImage, getToken, mode } = params;

	try {
		const token = await getToken();
		const apiUrl = mode === 'test' ? import.meta.env.VITE_API_URL_TEST : import.meta.env.VITE_API_URL;
		const body = {
			...metadata,
			...(thumbnail === undefined ? {} : { thumbnail }),
			...(dealId === undefined ? {} : { dealId }),
			...(designPackageImage === undefined ? {} : { designPackageImage })
		};
		const response = await axios.patch(`${apiUrl}/customers/${customerEmail}/blueprints/${designId}`, body, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status === 200) return [true, null];
		throw new Error('Error patching blueprint metadata');
	} catch (error) {
		console.log('patchBlueprintMetadata:error', error);
		return [false, 'Error patching blueprint metadata'];
	}
};
